function injectQueryParams(filename){
	let [name,...exts] = filename.split('.')
	let ext = exts.join(".")
	let query = window.location.search.replace('?','_')
	return `${name}${query}.${ext}`
}

export async function downloadBlob(blob, filename) {
	filename = injectQueryParams(filename)
	let url = window.URL.createObjectURL(blob)
	let a = document.createElement("a");
	document.body.appendChild(a);
	a.style = "display: none";
	a.href = url;
	a.download = filename;
	a.click();
	window.URL.revokeObjectURL(url);
	a.remove();
}
export async function downloadReport(url, params, filename = "report.xlsx") {
	try {
		let res = await fetch(`${process.env.REACT_APP_BACK_URL}/${url}`, {
			method: "POST",
			credentials: "include",
			headers: {
				"x-reqtype": "admin",
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(params)
		})
		if (res.status == 404) {
			throw "Not found";
		}
		if (res.status == 504) {
			throw "The report is not ready yet, try again later"
		}
		if (!res.ok) {
			throw new Error('Bad status code');
		}
		let blob = await res.blob()
		await downloadBlob(blob, filename)
	}
	catch (e) {
		console.error(e)
		if (typeof e == "string") {
			throw new Error(e);
		}
		throw new Error(`Can't download report`)
	}
}
